import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Grid,
  Button,
} from '@material-ui/core';
import { PopUp } from 'src/components/PopUp/BasePopUp';
import { useLayout } from 'src/utils/customHook';
import BaseDrawer from 'src/components/PopUp/BaseDrawer';
import authService from 'src/services/authService';
import CTextField from 'src/components/CTextField';
import PasswordValidator from 'src/components/PasswordValidator';

type regisDataType = "fullname" | "password" | "CFPassword" | "email" | "username";


interface ResetPasswordPopupProps {
  open : boolean
  onClose : ()=>void
  phoneNumber : string
  onSuccess : ()=>void
  title? : string
  brokerName? : string
  brokerID? : string
}

const ResetPasswordPopup: React.FC<ResetPasswordPopupProps> = ({
  onClose,
  open,
  title,
  phoneNumber,
  brokerName,
  brokerID,
  onSuccess,
}) => {
  const { isSmall } = useLayout();

  const [loading,setLoading] = useState(false);
  const [password, setPassword] = useState("");
  const [cfPassword, setCfPssword] = useState("");
  const [passwordValid,setPasswordValid] = useState(false)

  const [errorMessage, setErrorMessage] = useState("");

  useEffect(()=>{
    if (open) {
      setPassword("")
      setCfPssword("")
      setErrorMessage("")
      setLoading(false)
    }
  },[open])


  const handleChange = (type: regisDataType, val: string) => {
    setErrorMessage("");
    switch (type) {
      case "password" :
        return setPassword(val);
      case "CFPassword" :
        return setCfPssword(val);
      default:
        return;
    }
  };

  const handleValidate = () =>
  new Promise(async (resolve, reject) => {
    if (password !== cfPassword) reject({ type: "invalid", message: "รหัสผ่านไม่ตรงกัน" });
    if (!passwordValid) reject({ type: "invalid", message: "กรุณาตรวจสอบรหัสผ่านอีกครั้ง" });
    resolve(null);
  });

  const CFPasswordError = () => {
    return !!cfPassword && (password !== cfPassword)
  }


  // registeration : regis
  const onResetPassword = async () => {
    try {
      if (!brokerID) return setErrorMessage("Please select broker.")
      await handleValidate();
      await authService.resetPassword(
        password,
        brokerID,
      );
      onSuccess()
    } catch (err) {
      if (err.type === "invalid") {
        return setErrorMessage(err.message);
      }
      if (err?.response?.data?.message) {
        return setErrorMessage(err.response.data.message);
      }
      if (err) return setErrorMessage(err);
    }
  };

  const RenderContent = (
    <Box>
        <Box mt={3} />  
        <CTextField
          label="รหัสผ่าน"
          fullWidth
          value={password}
          variant="filled"
          type="password"
          onChange={(e) => handleChange("password", e.target.value)}
          helperText="รหัสผ่านต้องมีอย่างน้อย 8 ตัว"
        />
        <Box pl={2}>
         <PasswordValidator
          password={password}
          onChangeValid={(valid)=>setPasswordValid(valid)}
         />
        </Box>
        <Box mt={2} />
        <CTextField
          label="ยืนยันรหัสผ่าน"
          fullWidth
          value={cfPassword}
          variant="filled"
          type="password"
          error={CFPasswordError()}
          helperText={CFPasswordError() ? "รหัสผ่านไม่ตรงกัน":""}
          onChange={(e) => handleChange("CFPassword", e.target.value)}
        />
        <Box mt={1}/>
        <Typography color="secondary" variant="body2">
          {errorMessage}
        </Typography>
        <Box mt={3} />
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Button
              variant="contained"
              size="large"
              color="primary"
              fullWidth
              onClick={onResetPassword}
              disabled={loading || (password && (password !== cfPassword)) || !passwordValid}
            >
              เปลี่ยนรหัสผ่าน
            </Button>
          </Grid>
        </Grid>
      </Box>
  )

  if (isSmall) return (
    <BaseDrawer
      title={title || "ยืนยันหมายเลขโทรศัพท์"}
      open={open}
      onClose={onClose}
    >
      {RenderContent}
    </BaseDrawer>
  )

  return (
    <PopUp 
      title={title || "ยืนยันหมายเลขโทรศัพท์"}
      open={open}
      handleClose={onClose}
    >
      {RenderContent}
    </PopUp>
  )
}

export default ResetPasswordPopup;
